import { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { Auth } from "../components/Auth";
import { FormTaxpayer } from "../components/FormTaxpayer";
import { FormTransport } from "../components/FormTransport";
import NavBar from "../components/NavBar";
import { PrivateRoute } from "../components/PrivateRoute";
import { Options } from "../components/ViewOptions";

export default function App() {
  const [data, setData] = useState();
  useEffect(() => {
    const dataStorage = localStorage.getItem("data");
    setData(JSON.parse(dataStorage));
  }, []);

  return (
    <div>
      <Route path="/" component={NavBar} />
      <Route
        exact
        path="/"
        render={({ location }) => <Auth data={data} location={location} />}
      />

      <PrivateRoute
        path="/transporte"
        component={Options}
        isAuth={data?.idrafam !== "0"}
      />
      <PrivateRoute
        path="/tramite-transporte/:bromatologico"
        component={FormTransport}
        isAuth={data?.idrafam !== "0"}
      />
      <PrivateRoute
        exact
        path="/tramite-transporte"
        component={FormTransport}
        isAuth={data?.idrafam !== "0"}
      />
      <PrivateRoute
        path="/nuevo-contribuyente"
        component={FormTaxpayer}
        isAuth={data?.codigo && data?.idrafam === "0"}
      />
    </div>
  );
}
